// ---------------------------------------------------------------------------
// Initial state
// ---------------------------------------------------------------------------

import { none } from '@sapphire/result';
import {
  SurveyStateFilters,
  SurveyStatePagination,
  SurveyState,
} from './survey-state.model';

export const INITIAL_SURVEY_PAGINATION: Readonly<SurveyStatePagination> = {
  page: 1,
  limit: 20,
  hasMore: true,
};

export const INITIAL_SURVEY_FILTERS: Readonly<SurveyStateFilters> = {
  status: 'all',
  search: null,
  searchTitle: null,
};

export const INITIAL_SURVEY_STATE: SurveyState = {
  surveys: none,
  pagination: { ...INITIAL_SURVEY_PAGINATION },
  filters: { ...INITIAL_SURVEY_FILTERS },
  sort: null,
  context: {
    targeting: 0,
    isMultiBuyerRequest: false,
    isServiceBuyerRequest: false,
    mobile: false,
  },
  loading: false,
  error: null,
};
